import { createPinia } from "pinia";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp, markRaw } from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './registerServiceWorker'
import 'v-calendar/dist/style.css';
import vSelect from 'vue-select';
import VCalendar from 'v-calendar';
import router from './router';
import MainContainer from "./components/Container/MainContainer.vue";
import ListGroup from "./components/ListGroup/ListGroup.vue";
import ListItem from "./components/ListGroup/ListItem.vue";
import NavBar from "./components/NavBar/NavBar.vue";
import NavIcon from "./components/NavBar/NavIcon.vue";
import BottomBar from "./components/BottomBar/BottomBar.vue";
import AppNotification from "./components/Notification/AppNotification.vue";
import AccordionList from "./components/Accordion/AccordionList.vue";
import AccordionItem from "./components/Accordion/AccordionItem.vue";
import HumorEmojis from "./components/Humor/HumorEmojis.vue";
import CustomBadge from "./components/Badge/CustomBadge.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
pinia.use(({ store }) => {
    store.$router = markRaw(router)
  });

library.add(fas);

let app = createApp(App);

app
.use(pinia)
.component("font-awesome-icon", FontAwesomeIcon)
.component('v-select', vSelect)
.component('main-container', MainContainer)
.component('list-group', ListGroup)
.component('list-item', ListItem)
.component('nav-bar', NavBar)
.component('nav-icon', NavIcon)
.component('bottom-bar', BottomBar)
.component('app-notification', AppNotification)
.component('accordion-list', AccordionList)
.component('accordion-item', AccordionItem)
.component('humor-emojis', HumorEmojis)
.component('custom-badge', CustomBadge)
.use(VCalendar, {})
.use(router)
.mount('#app')